export var IdModal;
(function (IdModal) {
    IdModal["BalloonOffer"] = "BalloonOffer";
    IdModal["BuildingInfo"] = "BuildingInfo";
    IdModal["BuildingList"] = "BuildingList";
    IdModal["BuildingUpgrade"] = "BuildingUpgrade";
    IdModal["CharacterHelp"] = "CharacterHelp";
    IdModal["Cooperative"] = "Cooperative";
    IdModal["Disconnect"] = "Disconnect";
    IdModal["DisconnectedByLogin"] = "DisconnectedByLogin";
    IdModal["DogTreatReward"] = "DogTreatReward";
    IdModal["FacebookConnectAnotherPlayerConnect"] = "FacebookConnectAnotherPlayerConnect";
    IdModal["FacebookConnectAnotherPlayerConnected"] = "FacebookConnectAnotherPlayerConnected";
    IdModal["FacebookConnectAnotherPlayerLogout"] = "FacebookConnectAnotherPlayerLogout";
    IdModal["FacebookConnectFailure"] = "FacebookConnectFailure";
    IdModal["FarmManagement"] = "FarmManagement";
    IdModal["Feedback"] = "Feedback";
    IdModal["FeedbackConfirmation"] = "FeedbackConfirmation";
    IdModal["FortuneTellerEvent"] = "FortuneTellerEvent";
    IdModal["CollectReward"] = "CollectReward";
    IdModal["LevelUp"] = "LevelUp";
    IdModal["Maintenance"] = "Maintenance";
    IdModal["ManualUpdate"] = "ManualUpdate";
    IdModal["CooperativeLevelUp"] = "CoopLevelUp";
    IdModal["NotEnoughResource"] = "NotEnoughResource";
    IdModal["PendingInventory"] = "PendingInventory";
    IdModal["PlayerRanking"] = "PlayerRanking";
    IdModal["PurchaseExpansion"] = "PurchaseExpansion";
    IdModal["QuestIntros"] = "QuestIntros";
    IdModal["Quests"] = "Quests";
    IdModal["QuickSell"] = "QuickSell";
    IdModal["SetPlayerName"] = "SetPlayerName";
    IdModal["Settings"] = "Settings";
    IdModal["Shop"] = "Shop";
    IdModal["ShopGrowingGoldOffer"] = "ShopGrowingGoldOffer";
    IdModal["ShopInterstitialOffer"] = "ShopInterstitialOffer";
    IdModal["ShowAllRewards"] = "ShowAllRewards";
    IdModal["PaymentReward"] = "PaymentReward";
    IdModal["LeagueReward"] = "LeagueReward";
    IdModal["LeagueRewardSpecialOffer"] = "LeagueRewardSpecialOffer";
    IdModal["ConfirmBuyTournamentSpecialOffer"] = "ConfirmBuyTournamentSpecialOffer";
    IdModal["RankingLanguageFilter"] = "RankingLanguageFilter";
    IdModal["CoopLanguageFilter"] = "CoopLanguageFilter";
    IdModal["LogoutConfirmation"] = "LogoutConfirmation";
    IdModal["PlayerProfile"] = "PlayerProfile";
    IdModal["PlayerProfilePictureSelection"] = "PlayerProfilePictureSelection";
    IdModal["PlayerProfilePictureSelectionInfo"] = "PlayerProfilePictureSelectionInfo";
    IdModal["Coop"] = "Coop";
    IdModal["CoopInvitation"] = "CoopInvitation";
    IdModal["CoopInvite"] = "CoopInvite";
    IdModal["PromoteMobile"] = "PromoteMobile";
    IdModal["EnvSelect"] = "EnvSelect";
    IdModal["Store"] = "Store";
    IdModal["DiscountEvent"] = "DiscountEvent";
    IdModal["PromoteDemote"] = "PromoteDemote";
    IdModal["PurchasePointsEvent"] = "PurchasePointsEvent";
    IdModal["TraderEvent"] = "TraderEvent";
    IdModal["SpendGoldConfirmation"] = "SpendGoldConfirmation";
    IdModal["SkipProcess"] = "SkipProcess";
    // Outskirt building menus
    IdModal["Cafe"] = "Cafe";
    IdModal["Doghouse"] = "Doghouse";
    IdModal["DoghouseInfo"] = "DoghouseInfo";
    IdModal["ExternalBarnInfo"] = "ExternalBarnInfo";
    IdModal["ExternalBarnUpgrade"] = "ExternalBarnUpgrade";
    IdModal["Harbor"] = "Harbor";
    IdModal["Library"] = "Library";
    IdModal["Market"] = "Market";
    IdModal["Nursery"] = "Nursery";
    IdModal["Pier"] = "Pier";
    IdModal["ThemedEventDifficulty"] = "ThemedEventDifficulty";
    IdModal["ThemedEvent"] = "ThemedEvent";
    IdModal["ThemedEventReward"] = "ThemedEventReward";
    IdModal["TournamentTent"] = "TournamentTent";
    IdModal["WaterTower"] = "WaterTower";
    // Collect event
    IdModal["CollectEvent"] = "CollectEvent";
    // Cooperatives
    IdModal["CoopDemoteLeaderConfirm"] = "CoopDemoteLeaderConfirm";
    IdModal["CoopKick"] = "CoopKick";
    IdModal["CoopLeaveConfirm"] = "CoopLeaveConfirm";
    IdModal["CoopProjectStartConfirm"] = "CoopProjectStartConfirm";
    IdModal["CoopProjectStopConfirm"] = "CoopProjectStopConfirm";
    IdModal["CoopProjectCompleted"] = "CoopProjectCompleted";
    IdModal["CoopRoleManagement"] = "CoopRoleManagement";
    // Store
    IdModal["ShowAllRewardsStore"] = "ShowAllRewardsStore";
    IdModal["CollectRewardsStore"] = "CollectRewardsStore";
    // Web Exclusive
    IdModal["WebExclusiveReward"] = "WebExclusiveReward";
    IdModal["TerminationDialog"] = "TerminationDialog";
})(IdModal || (IdModal = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/modals/IdModal.ts
// module id = 7
// module chunks = 3